import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { LineChart, Line, XAxis, YAxis, Label, ResponsiveContainer } from 'recharts';
import Title from './Title';

const Chart = ({ sitevisits }) => {
    const theme = useTheme();
    const [datatomap, setdatatomap] = useState([]);

    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    useEffect(() => {
        const monthsData = Array.from({ length: 12 }, (_, month) => ({
            month: month + 1,
            visits: [],
        }));

        if (sitevisits?.length > 0) {
            sitevisits.forEach(visit => {
                const visitDate = new Date(visit.created_at);
                const monthIndex = visitDate.getMonth();
                monthsData[monthIndex].visits.push(visit);
            });
        }

        const finalarray = monthsData.map(({ month, visits }) => ({
            month: monthNames[month - 1], // Get month name from array
            amount: visits.length,
        }));

        setdatatomap(finalarray);
    }, [sitevisits]);

  


    return (
        <React.Fragment>
            <Title>Site Visits by Month</Title>
            <ResponsiveContainer width="100%" height={300} >
                <LineChart
                    data={datatomap}
                    margin={{
                        top: 16,
                        right: 16,
                        bottom: 0,
                        left: 24,
                    }}
                >
                    <XAxis
                        dataKey="month"
                        stroke={theme.palette.text.secondary}
                        style={theme.typography.body2}
                    />
                    <YAxis
                        stroke={theme.palette.text.secondary}
                        style={theme.typography.body2}
                    >
                        <Label 
                            angle={270}
                            position="left"
                            style={{
                                textAnchor: 'middle',
                                fill: theme.palette.text.primary,
                                ...theme.typography.body1,
                            }}
                        >
                            Site Visits
                        </Label>
                    </YAxis>
                    <Line
                        isAnimationActive={false}
                        type="monotone"
                        dataKey="amount"
                        stroke={theme.palette.primary.main}
                        dot={false}
                    />
                </LineChart>
            </ResponsiveContainer>
        </React.Fragment>
    );
}

export default Chart;



